import React from 'react';
import {Link} from 'react-router-dom';
import ToxicNav from './ToxicNav';

import '../css/Header.css';

const ToxicHeader = (props) => {
    function addClass() {
        document.getElementById("dropdown-block").style.display = 'block';
        document.getElementById("no-pointer").style.pointerEvents = 'none';
    }

    function removeClass() {
        document.getElementById("dropdown-block").style.display = '';
        document.getElementById("no-pointer").style.pointerEvents = '';
    }

    // function addClassClicked() {
    //     document.getElementById("dropdown-block").style.display = 'block';
    //     document.getElementById("no-pointer").style.pointerEvents = 'none';
    // }

    return (<div>
        <ToxicNav/>
        <div className="flexcontainer flexnav">
            {/* <h1 className="maintitle">School lookup tool
                    </h1> */
            }
            <div className="tab-group" id="navigation">
                <Link to="/">Search a school</Link>
                {/* <Link to="/schools">Schools overview</Link> */}

                <div className="dropdown" onMouseEnter={addClass} onMouseLeave={removeClass}>
                    <a  className="schools" id="no-pointer" >The Hazards <i className="fas fa-chevron-down"></i>
                    </a>
                    <div id="dropdown-block" className="dropdown-content">
                        <Link to="/lead-paint-residue" className="lead" onClick={removeClass}>Lead paint residue</Link>

                        <Link to="/asbestos" className="asbestos" onClick={removeClass}>Damaged asbestos</Link>
                        <Link to="/asthma-triggers" className="asthma" onClick={removeClass}>Asthma triggers</Link>
                        <Link to="/lead-water" className="water" onClick={removeClass}>Lead in drinking water</Link>
                    </div>
                </div>
                <Link to="/about" className="mobileHide">About the tool</Link>

            </div>
        </div>
        {/* <p className="leadin">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p> */}
    </div>);
}

export default ToxicHeader;



// WEBPACK FOOTER //
// ./src/components/ToxicHeader.js